<template>
      <v-card :dark="dark" v-bind="$attrs" v-if="isSingle" flat>
         
    <v-card-title class="primary--text font-weight-light">
        {{itemlist[0].name}}<v-spacer></v-spacer>
            <v-switch class="mt-0"
              :value="itemlist[0]._id || itemlist[0]" 
              :label="itemlist[0].price ? $options.filters.toCurrency(itemlist[0].price): ''" hide-details
              v-model="item"
              @change="updateMe"
              >
            </v-switch>
           
       </v-card-title>
       <v-card-subtitle v-text="getConfig('description')"></v-card-subtitle>  
       </v-card>    
    <v-card v-bind="$attrs" flat v-else @click="$emit('click')">
      <v-dialog
          v-model="dialog"
          width="500" style="z-index:100"
        ><v-card v-if="current">
          <v-toolbar tile
    :dark="dark"
     fixed flat
     class="border-bottom"
  >
  <v-toolbar-title class="primary--text font-weight-light" v-text="current.name">
        </v-toolbar-title>
          </v-toolbar>
        
        <v-card-text>
        <v-radio-group v-model="current.$volume" mandatory>
          <v-radio dense v-for="(volume,v) in current.volume" :key="v" :value="volume">
            <template v-slot:label>
              {{volume.name}}({{volume.price | toCurrency}})
            </template>
          </v-radio>
        </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="dialog = false"
          >
            Annuleren
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="setVolume"
          >
            Opslaan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-title class="font-weight-light">
     <span class="primary--text"><span v-if="isMinimized" class="mr-2">Zonder</span> {{getConfig('title',title)}}</span>
     <v-spacer></v-spacer>
     <span v-if="this.add.included>count" class="text-body-2 primary--text">{{count}}/{{add.included}} gekozen</span>
   
      </v-card-title>    
      <v-card-subtitle v-if="$slots.extra || isMinimized"><slot name="extra"><v-btn v-if="isMinimized" class="caption" text color="primary" @click="setItem()">Aanpassen</v-btn></slot></v-card-subtitle>
    <v-card-subtitle v-if="!required && !isMinimized && !noDescription">
      {{getConfig('description')}}.<br><span v-if="min>0"> Minimaal {{min}} </span>
         <span v-if="max>0 && max < 99"><span v-if="min>0"> en maximaal</span><span v-else> Maximaal</span> {{max}}</span><span v-if="this.add.included">, inbegrepen {{this.add.included}}.</span>
        
      </v-card-subtitle>  
    
    <v-expand-transition>
       
          <v-card-text class="py-0" v-if="!isMinimized && !required">
            <choose :inline="!showAll" :show="showAll" 
            @close="closeChoose">
            <template slot="activator">
                Kies
            </template>
            <template v-if="disabled"></template>
            <v-card-subtitle v-else-if="(!edit && !showAll)" class="pa-0 ma-0 primary--text" @click="edit=true">
               <slot name="info"><v-chip label small color="primary" class="mr-1 mb-1" outlined v-for="name in names" v-text="name" :key="name"></v-chip></slot>
            </v-card-subtitle>
            
            <v-list class="checklist py-0" expand v-else>
            <v-list-item-group 
              v-model="bounditems"
              multiple
            > 
              <template v-for="(listitem, i) in displayItems">
               <v-expand-transition :key="`${group}-item-${i}`">
                <v-list-item :class="{'pa-0 ma-0': !showAll}"
                  :value="listitem._id"
                  active-class="primary--text" @click="selectMe(listitem, i)" :disabled="!listitem.none && !bounditems.includes(listitem._id) && (max ? true:false) && count == max"
                >
                  <template v-slot:default="{ active }">
                     <v-list-item-action class="mr-2">
                      <v-checkbox 
                        :input-value="active"
                        color="primary" class="mt-0"
                         :off-icon="listitem.none ? 'close' : (multiple ? '$checkboxOff' : '$radioOff')" :on-icon="multiple ? '$checkboxOn' : '$radioOn'"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content class="py-0">
                      <v-list-item-title class="text-body-2" v-text="labelMe(listitem)"></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="listitem.none"><v-icon>chevron_right</v-icon></v-list-item-action>
                  
                   <template v-else-if="multiple">
                    <v-list-item-action v-if="bounditems.includes(listitem._id) && listitem.count>1" @click.stop>
                      <v-btn icon @click.stop="removeCount(listitem,i)"><v-icon color="grey" dense>mdi-minus</v-icon></v-btn>
                    </v-list-item-action>
                    <v-list-item-action v-if="listitem.count>1" class="mx-0 font-weight-bold" @click.stop>
                      {{listitem.count}}x
                    </v-list-item-action>
                    <v-list-item-action v-if="bounditems.includes(listitem._id) && (!max || count<max)" class="mx-0" @click.stop>
                        <v-btn icon dense @click.stop="addCount(listitem,i)"><v-icon color="grey" size="24">mdi-plus</v-icon></v-btn>
                      </v-list-item-action>
                    </template>
                    </template>
                </v-list-item>
               </v-expand-transition>
              </template>
            </v-list-item-group>
          </v-list>
          </choose>
         </v-card-text>
    </v-expand-transition>
        <v-card-actions class="pl-0 py-2" v-if="!isMinimized && !required">
             
          <v-btn class="caption" v-if="!showAll && edit && (itemlist.length>preselect.length || showAll) && itemlist.length > maxItems" color="primary" @click="showAll = true" text><v-icon class="mr-1">arrow_drop_down</v-icon>Extra {{getConfig('title',title)}}</v-btn>            
          <v-spacer></v-spacer>
          <v-btn v-if="!edit && !none" class="caption pa-0 ma-0 float-right" color="primary" @click="showAll=true" text style="height: auto;">
              <template v-if="bounditems.length > 0">Aanpassen...</template>
              <template v-else>Kiezen...</template>
              </v-btn>
          <v-btn class="caption" color="primary" @click="showAll = false;edit = false" text v-if="false && isSummary && edit && bounditems.length > 0 && itemlist.length>maxItems">Minder</v-btn>

          <!--v-btn v-if="none && !isNone" text color="primary" @click="setItem(none,true)">Zonder {{getConfig('title',title).toLowerCase()}}<v-icon>chevron_right</v-icon></v-btn-->
         
        </v-card-actions>
        </v-card>
</template>
<script>
import choose from '../components/choose.vue'
export default {
  components: {
    choose
  },
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      },
    },
    add: {
      type: Object,
      default: function () {
        return {}
      },
    },
    disabled: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    required: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    dark: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    list: {
      type: Array,
      default: function () {
        return []
      },
    },
    product: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data: () => ({
    
    maxItems: 5,
    dialog:false,
    current: null,
    currentIndex: null,
    edit: true,
    itemlist: [],
    showAll: false,
    bounditems: [],
    preselect: []
  }),
  computed: {
    none(){
      return this.list.filter(p=>p.none)[0]
    },
    group(){
      return this.add.group.split('-')[0]
    },
    config(){
      if (!this.group) return {}
      return this._config('include',this.group.toLowerCase())
    },
  title(){
    return this.add.title || this.group
  },
  noDescription(){
    return this.group.split(' ').length>2
  },
  multiple(){
    if (this.add.max && this.add.max == 1) return false
    return !this.add.min || this.add.min > 0
  },
  min(){
    return this.add.min
  },
  max(){
    return this.add.max
  },
  displayItems(){
      if (this.showAll) return this.itemlist.sort((a, b) => a.name.localeCompare(b.name));
      return this.preselect
  },
 /* preselectsss(){
    if (this.showAll) return this.itemlist
    if (this.value.value.length > 0) return this.itemlist.filter(l=>this.bounditems.includes(l._id))
    if (this.value.favorites) return this.itemlist.filter(l=>this.value.favorites.filter(f=>f.name==l.name).length>0)
    return this.itemlist.slice(0,this.maxItems)
  },*/
  item: {
   get(){
           return this.bounditems[0]
    },
    set(value){
      this.bounditems = [value]
    }
  },
  names(){
      return this.include.map(v=>(v.count>1 ? v.count + 'x ': '') + v.name);//.join(', ')//this.itemlist.filter(p=>this.add.includes(p._id)).map(v=>v.name).join(', ')
  },
  count(){
    let count = 0
    this.include.map(v=>count+=v.count || 1)
    return count
  },
  isFree(){
      return (this.add.included || 0) - this.count > 0 ? true : false
  },
  include(){
      return this.itemlist.filter(p=>this.bounditems.includes(p._id))
  },
  favorites(){
      return this.add.favorites || []
  },
  shortlist(){
    let arr = []
    if (this.value.length > 0 && this.multiple && !this.add.min>0) {
      arr = this.itemlist.filter(l=>this.bounditems.includes(l._id))
    }else if (this.add.favorites) {
      this.add.favorites.map(f=>{
        this.itemlist.filter(item=> item.name == f.name).map(item=>{
            item.count = f.count || 1
            arr.push(item)
        })
      })
    } else {
      arr = this.itemlist.slice(0,5)
    }
     if (arr.length==0) arr = this.itemlist.slice(0,5)
    return arr
  },
  isMinimized(){
    return false
  },
  isSingle(){
    return this.itemlist.length==1
  },
  isSummary(){
    return this.max == 99
  },
  isNone(){
    return this.none && this.bounditems.includes(this.none._id)
  }  
  },
  mounted () {
    this.init()
 },
watch: {
    bounditems(value){
      this.updateMe()
    },
    item(value){
      //console.log(this.include)
      //this.value = this.include
      //this.updateMe()
    }
},
methods: {
  init(){
    let list = this.value
    if (this.isSummary) this.edit = false
    let include = this.value || this.product.$include || this.product.include
    
    this.bounditems = include.filter(i=>i.group==this.add.group).map(i=>i._id)
    this.itemlist = this.clone(this.list).map(p=>{
      if (this.bounditems.includes(p._id)) p.included = true
      return p
    })
    //if (this.showAll) return this.itemlist
    this.preselect = this.shortlist
    list.filter(l=>l.count > 1).map(l=>{
    this.include.filter(ii=>ii.name==l.name).map(ii=>{
      ii.$quantity = l.$quantity
      ii.count = l.count
      return ii
    })
    })
    //return this.itemlist.slice(0,this.maxItems)
  },
  closeChoose(){
    this.showAll=false;
    this.preselect = this.shortlist
    this.edit = !this.isSummary
  },
  updateMe(){
    if (this.isSingle) this.include.map(i=>{i._single = true})
    this.$emit('input', this.include)
    this.$emit('update',this.include)
  },
  setItem(item,next){
      this.bounditems=item ? [item._id] : []
      if (!item) this.preselect = this.itemlist.filter(s=>!s.none)
      this.showAll = false
      this.edit = true
      this.updateMe()
      if (next) this.$emit('next',this.include)
  },
  labelMe(listitem){
    let label = []
    let price = listitem.price

    if (!listitem) return ''
    //if (listitem.count>1) label.push(listitem.count + 'x')
    if (listitem.$volume && listitem.$volume.name) {
      label.push(listitem.$volume.name)
      price = listitem.$volume.price
    }
    if (listitem.name) {
      label.push(listitem.name)
    } else {
      label.push(listitem)
    }
    //console.log(this.add.group,this.add.included,this.count, this.isFree)
      //if (listitem.count>1 && price> 0) price = price *listitem.count
    if (price> 0) label.push('(' + this.$options.filters.toCurrency(price) + ')')
    if (listitem.included) {
      label.push('*')
    }else if(this.add.extra || (this.count==0 && !this.add.included) || this.product.$subprice>0){
        
    }
    
    return label.join(' ')
  },
  addCount(listitem,i){
    this.itemlist = this.itemlist.map(item=>{
      if (!item.count) item.count = 1
      if (item._id==listitem._id) item.count++
      return item
    })
    this.updateMe()
  },
  removeCount(listitem,i){
    this.itemlist = this.itemlist.map(item=>{
      if (item._id==listitem._id) item.count--
      return item
    })
    this.updateMe()
  },
  isSelected(listitem){
    return this.bounditems.includes(listitem._id)
  },
  showMe(listitem,i){
    if (this.isSummary) return true
    if (this.isSelected(listitem)) return true
    if (this.bounditems.length>0) return false
    return i <this.maxItems
  },
  selectMe(listitem,i){
    
    setTimeout(()=>{
        if (!this.isSelected(listitem)) delete listitem.count
        this.current = this.isSelected(listitem) ? listitem : null
        this.currentIndex = i
        if (this.current && this.current.volume && this.current.volume.length>0) {
            this.dialog = true
        }
        if (!this.multiple || this.isNone) this.bounditems = [listitem._id]
        if (this.isNone) this.$emit('next',this.include)
     },200)
  },
  setVolume(){
      if (this.current.$volume) {
        this.current.price = this.current.$volume.price
        this.itemlist = this.itemlist.map(item=>{
            if (item._id==this.current._id) item.$volume = this.current.$volume
            return item
          })
      }
      this.updateMe()
      this.current = null
      this.currentIndex = null
      this.dialog=false
  },
  changeMe(listitem,i){

  },
  getConfig(key, def){
      let template = this.config[key]
      if (!template)  return def
      let product = this.product, label = this.title || this.group
      return eval('`' + template+ '`')
    },
 }
}

</script>
